import { Column } from 'components/Blocks';

import { MinFee } from './MinFee';
import { ExtraInformationForm } from './ExtraInformation';
import { Demographics } from './Demographics';
import { ReadyToInvoice } from './ReadyToInvoice';
import { TeamResponsible } from './TeamResponsible';
import { ProjectFiles } from './Files';

import { StepComponentProps } from '../types';

export function FinalDetails({ state, dispatch, handleChange }: StepComponentProps) {
  return (
    <>
      <Column gap="8">
        <TeamResponsible state={state} handleChange={handleChange} />

        <MinFee minFee={state.minFee} currency={state.currency} dispatch={dispatch} />

        <ReadyToInvoice value={state.readyToInvoice} dispatch={dispatch} />

        <ProjectFiles files={state.files} dispatch={dispatch} />
      </Column>

      <hr />

      <ExtraInformationForm extraInformation={state.observations} dispatch={dispatch} />

      <Demographics
        countries={state.countries}
        demographics={state.demographics}
        dispatch={dispatch}
      />
    </>
  );
}
